import {
  AdaptivityProvider,
  AppRoot,
  ConfigProvider,
  View
} from '@vkontakte/vkui';
import { AppPanelsT, routeConfig } from '../lib/routeConfig';

interface IVkProviderProps {
  activePanel: AppPanelsT;
}

export const RouteProvider = ({
  activePanel
}: IVkProviderProps) => (
  <ConfigProvider appearance='light'>
    <AdaptivityProvider>
      <AppRoot id='app' className='app'>
        <View activePanel={activePanel}>
          {routeConfig}
        </View>
      </AppRoot>
    </AdaptivityProvider>
  </ConfigProvider>
);
